<script>
  import VueCookies from 'vue-cookies';
  import { debounce, whenFastSimonReady, augmentHistoryReplaceState, getProductMetafieldFromFS, getProductCollectionMetafieldFromFS, trackFSViewportImpression, handleViewportSize, normalizeShopifyCollectionId, productRowMatchesShopifyProductId, logFastSimonError } from '@/lib/vue-helpers';
  import { emitter } from '@/main';
  import ProductListItem from '@/components/ProductListItem.vue';
  import ProductListPromo from '@/components/ProductListPromo.vue';
  import CompareProductsWidget from '@/components/CompareProductsWidget.vue';
  export default {
    name: 'CollectionProducts',
    components: {
      CompareProductsWidget,
      ProductListPromo,
      ProductListItem
    },
    data() {
      return {
        collectionHandle: '',
        collectionId: '',
        collectionName: '',
        descriptionMetafield: '',
        fastSimonResponseAction: 'facets and products',
        gridLarge: 0,
        gridSmall: 0,
        isNoResults: false,
        maxImages: 2,
        narrowBy: '',
        page: '',
        pageCount: '',
        pastPage: '',
        productCategoryMetafieldOneAttr: '',
        productCategoryMetafieldTwoAttr: '',
        productCategoryMetafieldOneCollectionAttr: '',
        productCategoryMetafieldTwoCollectionAttr: '',
        productReminderMetafieldEmbedAttr: '',
        products: [],
        productsPerPage: '',
        productsToCompare: new Set(),
        productsToCompareKey: 0,
        showCompareUI: false,
        compareKeepOpen: false,
        comparePlpSessionKey: `plp_compare_products_${window.location.hostname}`,
        productTypesExcluded: '',
        searchTerm: '',
        setReminderFormIdPopup: '',
        setReminderLinkText: '',
        showPage: false,
        sliderIDActive: '',
        sliderIDLast: '',
        sortBy: '',
        totalResults: '',
        url: new URL(window.location.href),
        debouncedCheckCurrentActiveSlider: null,
        debouncedSyncStateFromUrl: null,
        showSalePercentage: false,
        showRating: false,
        ratingStarColor: '',
        ratingCountColor: '',
        isFilterUpdate: false,
        sortUpdateHandler: null,
        searchUpdateHandler: null,
        pageUpdateHandler: null,
        scrollHandler: null,
        filterToggleHandler: null,
        filterUpdateHandler: null,
        lastReportedSearchKey: new Set(),
        lastReportedCollectionKey: new Set(),
        searchResultsCollection: '',
        trackedProducts: [],
        trackingRetryCounter: 0,
        cachedBadgeConfig: null,
        useFsProductData: false,
        isMobile: window.innerWidth <= (window.theme?.sizes?.medium || 767),
        productTileHeight: 0,
        resizeHandler: null,
        gridSizeLargeHandler: null,
        gridSizeSmallHandler: null,
        fsError: false,
        prepTrackedRetryCounter: 0,
        pendingComparePid: null,
        stickyComparePid: null,
        isRestoringComparePid: false,
        restoreComparePidHandler: null,
        forceCompareOn: false,
        plpRestoreScrollY: null,
        plpPageHideHandler: null,
        persistPlpCacheDebounced: null,
        /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
        comparePlpEnabled: true,
        comparePlpRecheckTimer: null,
        comparePlpRecheckAttempts: 0
        /* --- end Kameleoon Compare PLP experiment --- */
      };
    },
    created() {
      this.lastRequestId = 0;
      this.pendingRequests = 0;
      this.currentSetupRequestId = null;
    },
    mounted() {
      augmentHistoryReplaceState();
      this.handleViewportSize = handleViewportSize(this);
      this.resizeHandler = () => {
        this.isMobile = window.innerWidth <= (window.theme?.sizes?.medium || 767);
        this.measureProductTileHeight();
      };
      document.addEventListener('theme:resize:width', this.resizeHandler);
      this.maxImages = parseInt(this.$el.parentElement.getAttribute('data-plp_max_images'));
      this.initializeBadgeHideConfig();
      this.debouncedCheckCurrentActiveSlider = debounce(this.checkCurrentActiveSlider, 100);
      this.debouncedSyncStateFromUrl = debounce(this.syncStateFromUrl, 300);
      this.persistPlpCacheDebounced = debounce(this.persistPlpCache, 400);
      this.plpPageHideHandler = () => this.savePlpScrollToCache();
      window.addEventListener('pagehide', this.plpPageHideHandler);
      this.sortUpdateHandler = e => {
        if (this.fsError) return;
        this.isFilterUpdate = true;
        this.sortBy = e;
        this.page = 1;
        this.pastPage = '1';
        this.products = [];
        this.lastReportedSearchKey = new Set();
        this.lastReportedCollectionKey = new Set();
        this.startCollectionPage();
        this.scrollToView();
        setTimeout(() => {
          this.isFilterUpdate = false;
        }, 2000);
      };
      emitter.on('fs-sort-update', this.sortUpdateHandler);
      this.searchUpdateHandler = e => {
        if (this.fsError) return;
        this.isFilterUpdate = true;
        this.searchTerm = e;
        this.page = 1;
        this.pastPage = '1';
        this.products = [];
        this.narrowBy = [];
        this.lastReportedSearchKey = new Set();
        this.lastReportedCollectionKey = new Set();
        this.removeUrlParam('current');
        emitter.emit('fs-new-search-reset', { page: 1 });
        this.startSearchTermPage();
        this.scrollToView();
        setTimeout(() => {
          this.isFilterUpdate = false;
        }, 2000);
      };
      emitter.on('fs-search-update', this.searchUpdateHandler);
      this.pageUpdateHandler = e => {
        if (this.fsError) return;
        const blocked = this.isFilterUpdate || this.pendingRequests > 0;
        if (blocked) {
          return;
        }
        this.page = e;
        this.endlessScrollCollectionPage();
      };
      emitter.on('fs-update-page', this.pageUpdateHandler);
      this.filterUpdateHandler = e => {
        if (this.fsError) return;
        const incomingNarrow = Array.isArray(e) ? e : this.getCurrentFilters();
        this.isFilterUpdate = true;
        this.narrowBy = incomingNarrow;
        this.page = 1;
        this.pastPage = '1';
        this.products = [];
        this.lastReportedSearchKey = new Set();
        this.lastReportedCollectionKey = new Set();
        this.setUrlParam('current', this.page);
        emitter.emit('fs-filter-reset');
        this.startCollectionPage();
        this.scrollToView();
        setTimeout(() => {
          this.isFilterUpdate = false;
        }, 2000);
      };
      emitter.on('fs-update-filter', this.filterUpdateHandler);
      window.addEventListener('replacestate', this.debouncedSyncStateFromUrl);
      this.sortBy = this.getCurrentSort();
      const initialPage = this.getCurrentPage() || 1;
      this.pastPage = initialPage;
      this.stickyComparePid = this.url.searchParams.get('compare_pid') || null;
      this.stickyCompareColor = this.url.searchParams.get('compare_color') || null;
      this.pendingComparePid = this.stickyComparePid;
      if (this.stickyComparePid) {
        try {
          sessionStorage.removeItem(this.comparePlpSessionKey);
        } catch (e) {
          console.error('Error clearing compare session for compare_pid URL:', e);
        }
      }
      this.restoreComparePidHandler = () => {
        this.restoreComparePidIfNeededToUrl();
      };
      window.addEventListener('replacestate', this.restoreComparePidHandler);
      window.addEventListener('pushstate', this.restoreComparePidHandler);
      this.loadCompareProducts();
      this.narrowBy = this.getCurrentFilters();
      this.searchTerm = this.getSearchTerm();
      this.collectionId = document.getElementById('fs-collection-products')?.getAttribute('data-collection-id');
      this.collectionHandle = document.getElementById('fs-collection-products')?.getAttribute('data-collection-handle');
      this.forceCompareOn = document.getElementById('fs-collection-products')?.getAttribute('data-plp-force-compare-on') === 'true';
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      // KAM A/B signal: add `kam-plp-compare` or `kam-plp-compare-off` on <html>,
      // or set window.theme.kameleoonComparePlpEnabled via Kameleoon variation JS.
      // engine.js is async while gm.js is a deferred module, so the signal can land
      // after mount; startComparePlpRecheck re-resolves for a bounded window.
      this.comparePlpEnabled = this.resolveComparePlpEnabled();
      /* --- end Kameleoon Compare PLP experiment --- */
      this.checkCompareEnabled();
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      this.startComparePlpRecheck();
      /* --- end Kameleoon Compare PLP experiment --- */
      this.productsPerPage = parseInt(document.getElementById('fs-collection-products')?.getAttribute('data-product_limit')) || 36;
      this.useFsProductData = document.getElementById('fs-collection-products')?.getAttribute('data-use_fs_product_data');
      this.gridLarge = Number(document.getElementById('fs-collection-products')?.getAttribute('data-grid-large'));
      this.gridSmall = Number(document.getElementById('fs-collection-products')?.getAttribute('data-grid-small'));
      this.gridLarge = VueCookies.get('gridViewLarge') ? JSON.parse(VueCookies.get('gridViewLarge')) : this.gridLarge;
      this.gridSmall = VueCookies.get('gridViewSmall') ? JSON.parse(VueCookies.get('gridViewSmall')) : this.gridSmall;
      this.gridSizeLargeHandler = e => {
        this.gridLarge = Number(e);
        this.measureProductTileHeight();
      };
      this.gridSizeSmallHandler = e => {
        this.gridSmall = Number(e);
        this.measureProductTileHeight();
      };
      emitter.on('fs-update-grid-size-large', this.gridSizeLargeHandler);
      emitter.on('fs-update-grid-size-small', this.gridSizeSmallHandler);
      const filterToggle = document.getElementById('filter-toggle');
      if (filterToggle !== null) {
        this.filterToggleHandler = function () {
          emitter.emit('fs-sidebar-click');
        };
        filterToggle.addEventListener('click', this.filterToggleHandler);
      }
      this.searchResultsCollection = this.$el.parentElement.getAttribute('data-search-results-collection');
      this.swatch_suffix = this.$el.parentElement.getAttribute('data-swatch_suffix');
      this.productTypesExcluded = this.$el.parentElement.getAttribute('data-excluded_product_type');
      this.productCategoryMetafieldOneAttr = window.siteGlobals.product_cat_metafield_one || '';
      this.productCategoryMetafieldTwoAttr = window.siteGlobals.product_cat_metafield_two || '';
      this.productCategoryMetafieldOneCollectionAttr = window.siteGlobals.product_cat_metafield_one_collection || '';
      this.productCategoryMetafieldTwoCollectionAttr = window.siteGlobals.product_cat_metafield_two_collection || '';

      // Get the metafield for 'Set a reminder'
      this.productReminderMetafieldEmbedAttr = window.siteGlobals.set_reminder_metafield;
      this.setReminderLinkText = window.siteGlobals.set_reminder_link_text;
      this.setReminderFormIdPopup = this.$el.parentElement.getAttribute('data-klaviyo_form_id_popup');
      this.descriptionMetafield = this.$el.parentElement.getAttribute('data-description_metafield');
      this.showSalePercentage = this.$el.parentElement.dataset.plpShowSalePercentage;
      this.showRating = this.$el.parentElement.dataset.plpShowRating === 'true';
      this.ratingStarColor = this.$el.parentElement.getAttribute('data-plp-rating-star-color') || '';
      this.ratingCountColor = this.$el.parentElement.getAttribute('data-plp-rating-count-color') || '';

      if (this.pendingComparePid) {
        this.page = 1;
        this.pastPage = '1';
        emitter.emit('plp-compare-pid-active', true);
      } else {
        this.page = initialPage;
      }

      // Back/forward restore: paint cached products + scroll instantly so the grid
      // doesn't flash the loading shimmer. The fetch below still runs to refresh
      // facets/filters and reconcile, but the shopper sees the previous view at once.
      this.maybeRestorePlpFromCache();
      if (this.searchTerm !== '1') {
        this.startSearchTermPage();
      } else {
        this.startCollectionPage();
      }
      if (this.searchTerm != '') {
        const self = this;
        this.scrollHandler = debounce(function () {
          if (window.handleSearchResultsView) {
            window.handleSearchResultsView(self.searchTerm, self.totalResults);
          }
        });
        window.addEventListener('scroll', this.scrollHandler);
      }
    },
    beforeUnmount() {
      emitter.emit('plp-compare-pid-active', false);
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      this.stopComparePlpRecheck();
      /* --- end Kameleoon Compare PLP experiment --- */
      if (this.restoreComparePidHandler) {
        window.removeEventListener('replacestate', this.restoreComparePidHandler);
        window.removeEventListener('pushstate', this.restoreComparePidHandler);
      }
      if (this.handleViewportSize) this.handleViewportSize();
      if (this.resizeHandler) document.removeEventListener('theme:resize:width', this.resizeHandler);
      window.removeEventListener('replacestate', this.debouncedSyncStateFromUrl);
      this.sortUpdateHandler && emitter.off('fs-sort-update', this.sortUpdateHandler);
      this.searchUpdateHandler && emitter.off('fs-search-update', this.searchUpdateHandler);
      this.pageUpdateHandler && emitter.off('fs-update-page', this.pageUpdateHandler);
      this.filterUpdateHandler && emitter.off('fs-update-filter', this.filterUpdateHandler);
      this.gridSizeLargeHandler && emitter.off('fs-update-grid-size-large', this.gridSizeLargeHandler);
      this.gridSizeSmallHandler && emitter.off('fs-update-grid-size-small', this.gridSizeSmallHandler);
      this.scrollHandler && window.removeEventListener('scroll', this.scrollHandler);
      if (this.plpPageHideHandler) {
        window.removeEventListener('pagehide', this.plpPageHideHandler);
      }
      this.savePlpScrollToCache();
      if (this.filterToggleHandler) {
        const filterToggle = document.getElementById('filter-toggle');
        if (filterToggle) {
          filterToggle.removeEventListener('click', this.filterToggleHandler);
        }
      }
    },
    methods: {
      initializeBadgeHideConfig() {
        try {
          const sectionId = document.querySelector('[data-section-type="collection"]')?.getAttribute('data-section-id');
          if (!sectionId) {
            console.warn('Collection section ID not found');
            this.cachedBadgeConfig = {};
            return;
          }
          const configScript = document.getElementById(`badge-hide-config-${sectionId}`);
          if (!configScript) {
            console.warn(`Badge hide config script not found: badge-hide-config-${sectionId}`);
            this.cachedBadgeConfig = {};
            return;
          }
          const rawConfig = JSON.parse(configScript.textContent);
          const processGroup = group => {
            const processed = {};
            for (const [key, value] of Object.entries(group)) {
              if (typeof value === 'string' && value.trim()) {
                const normalizedIds = value
                  .split(',')
                  .map(id => id.trim().replace(/[\s_-]/g, ''))
                  .filter(id => id.length > 0);
                processed[key] = new Set(normalizedIds);
              } else {
                processed[key] = new Set();
              }
            }
            return processed;
          };
          this.cachedBadgeConfig = {
            topLeft: processGroup(rawConfig.topLeft || {}),
            pill: processGroup(rawConfig.pill || {}),
            textUnderPrice: processGroup(rawConfig.textUnderPrice || {})
          };
        } catch (error) {
          console.warn('Failed to parse badge hide configuration:', error);
          this.cachedBadgeConfig = {};
        }
      },
      syncStateFromUrl(event) {
        if (this.fsError) return;
        if (this.isFilterUpdate) {
          return;
        }
        const newUrl = new URL(event.detail.url, window.location.origin);
        const oldFilters = this.url.searchParams.get('filters');
        const newFilters = newUrl.searchParams.get('filters');
        const oldSort = this.url.searchParams.get('sortBy');
        const newSort = newUrl.searchParams.get('sortBy');
        const newCollectionHandle = document.getElementById('fs-collection-products')?.getAttribute('data-collection-handle');
        if (newCollectionHandle && newCollectionHandle !== this.collectionHandle) {
          this.collectionHandle = newCollectionHandle;
          this.checkCompareEnabled();
        }
        this.url = newUrl;
        if (oldFilters !== newFilters || oldSort !== newSort) {
          this.page = 1;
          this.pastPage = '1';
          this.products = [];
          this.narrowBy = this.getCurrentFilters();
          this.setUrlParam('current', 1);
          emitter.emit('fs-filter-reset');
          this.startCollectionPage();
          this.scrollToView();
        }
      },
      scrollToView() {
        const scrollDiv = document.getElementById('collection-start')?.offsetTop || 0;
        const selectors = ['.collection__text-content', '.collection__nav--fs'];
        const offset = selectors.reduce((totalHeight, selector) => {
          const element = document.querySelector(selector);
          return totalHeight + (element ? element.offsetHeight : 0);
        }, 40);
        window.scrollTo({ top: scrollDiv - offset, behavior: 'smooth' });
      },
      getCurrentSort() {
        return this.getUrlParam('sortBy') || 'relevency';
      },
      getCurrentPage() {
        return parseInt(this.getUrlParam('current') || '1');
      },
      getSearchTerm() {
        return this.getUrlParam('q') || '1';
      },
      getCurrentFilters() {
        let filters = this.getUrlParam('filters');
        if (filters) {
          return JSON.parse(decodeURIComponent(filters));
        }
        return [];
      },
      getFilteredNarrowBy() {
        if (!this.narrowBy || !Array.isArray(this.narrowBy)) {
          return [];
        }
        return this.narrowBy;
      },
      getUrlParam(param) {
        return this.url.searchParams.get(param);
      },
      isBackForwardNavigation() {
        try {
          const navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
          if (navEntries && navEntries.length) {
            return navEntries[0].type === 'back_forward';
          }
          if (performance.navigation) {
            return performance.navigation.type === 2;
          }
        } catch (e) {
          return false;
        }
        return false;
      },
      plpCacheKey() {
        const u = new URL(window.location.href);
        u.searchParams.delete('compare_pid');
        u.searchParams.delete('compare_color');
        return `fsplp:${u.pathname}${u.search}`;
      },
      readPlpCache() {
        try {
          const raw = sessionStorage.getItem(this.plpCacheKey());
          if (!raw) return null;
          const data = JSON.parse(raw);
          if (!data || data.v !== 1) return null;
          return data;
        } catch (e) {
          return null;
        }
      },
      prunePlpCache() {
        // Keep sessionStorage bounded: drop other PLP entries once we hit the cap.
        try {
          const keys = [];
          for (let i = 0; i < sessionStorage.length; i++) {
            const k = sessionStorage.key(i);
            if (k && k.indexOf('fsplp:') === 0) keys.push(k);
          }
          if (keys.length >= 5) {
            const current = this.plpCacheKey();
            keys.forEach(k => {
              if (k !== current) sessionStorage.removeItem(k);
            });
          }
        } catch (e) {
          // ignore
        }
      },
      clearPlpCache() {
        try {
          for (let i = sessionStorage.length - 1; i >= 0; i--) {
            const k = sessionStorage.key(i);
            if (k && k.indexOf('fsplp:') === 0) sessionStorage.removeItem(k);
          }
        } catch (e) {
          // ignore
        }
      },
      persistPlpCache() {
        // Snapshot the accumulated result set so a back/forward navigation can repaint
        // instantly instead of re-fetching every page. Deep-link (compare_pid) states are
        // skipped. Any quota/serialization failure is swallowed so the PLP is unaffected.
        try {
          if (window.theme && window.theme.plpRestoreDisabled) return;
          if (this.pendingComparePid || this.stickyComparePid) return;
          if (!Array.isArray(this.products) || this.products.length === 0) return;
          const payload = {
            v: 1,
            products: this.products,
            page: this.page,
            pageCount: this.pageCount,
            totalResults: this.totalResults,
            collectionName: this.collectionName,
            narrowBy: this.narrowBy || [],
            sortBy: this.sortBy,
            searchTerm: this.searchTerm,
            scrollY: window.scrollY || window.pageYOffset || 0
          };
          this.prunePlpCache();
          sessionStorage.setItem(this.plpCacheKey(), JSON.stringify(payload));
        } catch (e) {
          console.debug('[plp-restore] persist skipped:', e);
          this.clearPlpCache();
        }
      },
      savePlpScrollToCache() {
        // Update just the scroll position on the existing entry as the shopper leaves.
        try {
          if (window.theme && window.theme.plpRestoreDisabled) return;
          const key = this.plpCacheKey();
          const raw = sessionStorage.getItem(key);
          if (!raw) {
            this.persistPlpCache();
            return;
          }
          const data = JSON.parse(raw);
          data.scrollY = window.scrollY || window.pageYOffset || 0;
          sessionStorage.setItem(key, JSON.stringify(data));
        } catch (e) {
          // ignore
        }
      },
      maybeRestorePlpFromCache() {
        try {
          if (window.theme && window.theme.plpRestoreDisabled) return false;
          if (this.pendingComparePid) return false;
          if (!this.isBackForwardNavigation()) return false;
          const cached = this.readPlpCache();
          if (!cached || !Array.isArray(cached.products) || cached.products.length === 0) return false;
          // Only restore when the cached request shape matches the current URL state.
          if (cached.sortBy !== this.sortBy) return false;
          if ((cached.searchTerm || '1') !== (this.searchTerm || '1')) return false;
          if (JSON.stringify(cached.narrowBy || []) !== JSON.stringify(this.narrowBy || [])) return false;
          this.products = cached.products;
          this.pageCount = cached.pageCount;
          this.totalResults = cached.totalResults;
          if (cached.collectionName) this.collectionName = cached.collectionName;
          this.page = cached.page;
          // Match pastPage to the restored page so setupProducts doesn't chase and
          // re-fetch every page again; the single fetch below just refreshes facets.
          this.pastPage = String(cached.page);
          this.removePreviewImages();
          requestAnimationFrame(() => {
            emitter.emit('fs-update-pager', {
              pageCount: this.pageCount,
              totalResults: this.totalResults,
              page: this.page
            });
          });
          this.plpRestoreScrollY = typeof cached.scrollY === 'number' ? cached.scrollY : null;
          this.restorePlpScroll();
          return true;
        } catch (e) {
          console.debug('[plp-restore] seed failed:', e);
          return false;
        }
      },
      restorePlpScroll() {
        if (this.plpRestoreScrollY == null) return;
        try {
          if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        } catch (e) {
          // ignore
        }
        const targetY = this.plpRestoreScrollY;
        const attempt = tries => {
          this.$nextTick(() => {
            window.scrollTo(0, targetY);
            // Product images grow the page as they load; retry until the target is
            // reachable, then stop.
            if (tries > 0 && Math.abs((window.scrollY || window.pageYOffset || 0) - targetY) > 4) {
              setTimeout(() => attempt(tries - 1), 120);
            }
          });
        };
        requestAnimationFrame(() => attempt(8));
      },
      removePreviewImages() {
        this.showPage = true;
        document.getElementById('fs-collection-products-preview')?.remove();
      },
      setupProducts(data) {
        if (this.currentSetupRequestId !== null && this.currentSetupRequestId !== this.lastRequestId) {
          return;
        }
        let allProducts = this.products;
        let newProductsToValidate = [];
        let allProductIds = [];
        allProducts.forEach(product => {
          allProductIds.push(product.id);
        });
        data.payload.products.forEach(product => {
          let isDuplicate = allProductIds.includes(product.id);
          if (!isDuplicate) {
            newProductsToValidate.push(product);
          }
        });
        allProducts = this.products.length > 0 ? this.products.concat(newProductsToValidate) : newProductsToValidate;
        if (data.action == this.fastSimonResponseAction || data.action == 'products') {
          this.collectionName = data.payload.name;
          this.products = allProducts;
          if (this.pendingComparePid) {
            const match = this.products.find(p => productRowMatchesShopifyProductId(p, this.pendingComparePid));
            if (match) {
              this.pendingComparePid = null;
              this.stickyComparePid = null;
              emitter.emit('plp-compare-pid-active', false);
              this.$nextTick(() => {
                /* --- Kameleoon Compare PLP experiment: remove this guard when experiment ends --- */
                // Skip the restore entirely when the bucket is off, otherwise toggleCompareItem
                // writes the compare set to sessionStorage for control visitors.
                if (!this.resolveComparePlpEnabled()) {
                  this.checkCompareEnabled();
                  return;
                }
                /* --- end Kameleoon Compare PLP experiment --- */
                if (this.productsToCompare.size >= 3) {
                  const trimmed = Array.from(this.productsToCompare);
                  while (trimmed.length >= 3) trimmed.shift();
                  this.updateProductsToCompare(new Set(trimmed));
                }
                if (this.stickyCompareColor) {
                  match.compareImage = this.getCompareImageForColor(match, this.stickyCompareColor);
                }
                this.toggleCompareItem(match);
                this.showCompareUI = true;
                this.checkCompareEnabled();
              });
            } else {
              const pl = data.payload;
              const pageNum = pl.page;
              const maxPage = pl.pageCount;
              if (pageNum < maxPage) {
                const pastPageNum = parseInt(this.pastPage) || 0;
                const pastPageChasing = !this.isFilterUpdate && pastPageNum > pageNum && pastPageNum > 1;
                if (!pastPageChasing || this.pendingComparePid) {
                  this.$nextTick(() => {
                    this.page = pageNum + 1;
                    if (this.searchTerm !== '' && this.searchTerm !== '1') {
                      this.startSearchTermPage();
                    } else {
                      this.startCollectionPage();
                    }
                  });
                }
              } else {
                this.pendingComparePid = null;
                this.stickyComparePid = null;
                emitter.emit('plp-compare-pid-active', false);
              }
            }
          }
          this.pageCount = data.payload.pageCount;
          this.totalResults = data.payload.totalResults;
          this.page = data.payload.page;
          if (window.setFindingMethod) {
            window.setFindingMethod('PLP:' + this.collectionName);
          }
          requestAnimationFrame(() => {
            emitter.emit('fs-update-pager', {
              pageCount: this.pageCount,
              totalResults: this.totalResults,
              page: this.page
            });
          });
          this.setUrlParam('current', this.page);
          this.persistPlpCacheDebounced && this.persistPlpCacheDebounced();
          const pastPageNum = parseInt(this.pastPage) || 0;
          if (this.page === pastPageNum && pastPageNum > 1) {
            const isSearch = this.searchTerm !== '' && this.searchTerm !== '1';
            this.reportAllPagesUpTo(this.page, isSearch);
          }

          if (!this.pendingComparePid && !this.isFilterUpdate && pastPageNum > this.page && pastPageNum > 1) {
            var pageIndex = this.page + 1;
            this.page = pageIndex;
            this.startCollectionPage();
          }
          if (this.isFilterUpdate) {
            setTimeout(() => {
              this.isFilterUpdate = false;
            }, 1000);
          }
          setTimeout(() => {
            this.removePreviewImages();

            if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.guids) {
              try {
                const guids = Object.keys(window.yotpoWidgetsContainer.guids);
                if (guids.length > 0) {
                  guids.forEach(guid => {
                    const guidConfig = window.yotpoWidgetsContainer.guids[guid];
                    const widgets = guidConfig.config.widgets;
                    Object.keys(widgets).forEach(widgetId => {
                      const widget = widgets[widgetId];
                      window.dispatchEvent(
                        new CustomEvent('yotpo-widget-refresh', {
                          detail: { widgetId, className: widget.className }
                        })
                      );
                      window.dispatchEvent(new CustomEvent(`yotpo-${widget.className}-refresh`));
                    });
                  });
                  setTimeout(() => {
                    const yotpoElements = document.querySelectorAll('[data-yotpo-instance-id]');
                    yotpoElements.forEach(element => {
                      element.setAttribute('data-yotpo-refreshed', Date.now().toString());
                    });
                  }, 100);
                }
              } catch (error) {
                console.warn('Yotpo widget refresh failed:', error.message);
              }
            }
          }, 500);
          if (this.products.length) {
            let urlPid = null;
            try {
              urlPid = new URL(window.location.href).searchParams.get('compare_pid');
            } catch (err) {
              urlPid = null;
            }
            if (urlPid && this.productsToCompare.size === 0) {
              const urlMatch = this.products.find(p => productRowMatchesShopifyProductId(p, urlPid));
              if (urlMatch) {
                this.$nextTick(() => {
                  if (this.productsToCompare.size > 0) return;
                  /* --- Kameleoon Compare PLP experiment: remove this guard when experiment ends --- */
                  // Skip the restore entirely when the bucket is off, otherwise toggleCompareItem
                  // writes the compare set to sessionStorage for control visitors.
                  if (!this.resolveComparePlpEnabled()) {
                    this.checkCompareEnabled();
                    return;
                  }
                  /* --- end Kameleoon Compare PLP experiment --- */
                  if (this.stickyCompareColor) {
                    urlMatch.compareImage = this.getCompareImageForColor(urlMatch, this.stickyCompareColor);
                  }
                  this.toggleCompareItem(urlMatch);
                  this.showCompareUI = true;
                  this.checkCompareEnabled();
                });
              }
            }
          }
          setTimeout(() => {
            this.measureProductTileHeight();
          }, 800);
        }
        if (this.searchTerm != '') {
          setTimeout(() => {
            window.handleSearchResultsView(this.searchTerm, this.totalResults);
          }, 250);
        }
        if (!data.payload.totalResults) {
          this.isNoResults = true;
        }
        this.prepTrackedProducts();
      },
      prepTrackedProducts() {
        let foundProducts = true;
        this.products.forEach(product => {
          if (!document.getElementById('pid-' + product.id)) {
            foundProducts = false;
          }
        });
        if (!foundProducts && this.prepTrackedRetryCounter < 50) {
          this.prepTrackedRetryCounter++;
          setTimeout(() => {
            this.prepTrackedProducts();
          }, 100);
        } else {
          this.prepTrackedRetryCounter = 0;
          this.setTrackedProducts();
        }
      },
      setTrackedProducts() {
        this.products.forEach(product => {
          if (document.getElementById('product-tile-' + product.id)) {
            if (!this.trackedProducts.includes(product.id)) {
              this.trackedProducts.push(product.id);
            }
          }
        });

        if (this.trackedProducts.length < this.products.length && this.trackingRetryCounter < 10) {
          setTimeout(() => {
            this.setTrackedProducts();
            this.trackingRetryCounter++;
          }, 100);
        } else {
          this.trackedProducts.forEach((product, index) => {
            trackFSViewportImpression(product, index);
            this.trackingRetryCounter = 0;
          });
        }
      },
      restoreComparePidIfNeededToUrl() {
        const sticky = this.stickyComparePid;
        if (sticky && !this.isRestoringComparePid) {
          try {
            const url = new URL(window.location.href);
            if (url.pathname.includes('/collections/')) {
              const existing = url.searchParams.get('compare_pid');
              if (existing !== String(sticky) && (existing == null || existing === '')) {
                this.isRestoringComparePid = true;
                url.searchParams.set('compare_pid', String(sticky));
                window.history.replaceState(null, null, url);
                this.url = new URL(url.toString());
                this.$nextTick(() => {
                  this.isRestoringComparePid = false;
                });
              }
            }
          } catch (error) {
            console.error('Error restoring compare_pid to URL:', error);
          }
        }
      },
      setUrlParam(paramName, paramValue) {
        const url = new URL(window.location.href);
        url.searchParams.set(paramName, String(paramValue));
        const cpid = this.comparePidForUrl;
        if (cpid) {
          url.searchParams.set('compare_pid', String(cpid));
        }
        window.history.replaceState(null, null, url);
        this.url = new URL(url.toString());
      },
      removeUrlParam(paramName) {
        const url = new URL(window.location.href);
        url.searchParams.delete(paramName);
        const cpid = this.comparePidForUrl;
        if (paramName !== 'compare_pid' && cpid) {
          url.searchParams.set('compare_pid', String(cpid));
        }
        window.history.replaceState(null, null, url);
        this.url = new URL(url.toString());
      },
      startSearchTermPage() {
        if ((this.searchTerm === '1' || this.searchTerm === '') && this.searchResultsCollection != '') {
          window.location.href = '/collections/' + this.searchResultsCollection;
          return;
        }
        if (window.setFindingMethod) {
          window.setFindingMethod('Search Results');
        }
        whenFastSimonReady(
          () => {
            try {
              if (!window.FastSimonSDK?.fullTextSearch) {
                console.warn('FastSimon SDK not available or fullTextSearch method missing');
                this.fsError = true;
                return;
              }
              let callbackFired = false;
              const callbackTimeout = setTimeout(() => {
                if (!callbackFired) {
                  logFastSimonError('fullTextSearch callback not received within 15s');
                  this.fsError = true;
                }
              }, 15000);
              const requestId = ++this.lastRequestId;
              this.pendingRequests += 1;
              const sentNarrow = this.getFilteredNarrowBy();
              window.FastSimonSDK.fullTextSearch({
                narrowBy: sentNarrow,
                page: this.page,
                productsPerPage: this.productsPerPage,
                sortBy: this.sortBy,
                term: this.searchTerm,
                withAttributes: true,
                maxFacetValues: 100,
                facetLimit: 100,
                includeFacetsFromAllResults: true,
                callback: response => {
                  callbackFired = true;
                  clearTimeout(callbackTimeout);
                  this.pendingRequests -= 1;
                  if (requestId !== this.lastRequestId) {
                    return;
                  }
                  this.currentSetupRequestId = requestId;
                  this.setupProducts(response);
                  emitter.emit('fs-update', response.payload);
                  if (!response.payload.totalResults) {
                    this.isNoResults = true;
                  } else {
                    this.isNoResults = false;
                  }
                  if (response.payload.products && response.payload.products.length > 0) {
                    this.reportSearchResultPageViewed();
                  }
                }
              });
            } catch (error) {
              logFastSimonError('fullTextSearch error', error);
              this.fsError = true;
            }
          },
          {
            onTimeout: () => {
              this.fsError = true;
            }
          }
        );
      },
      /**
       * Initialize product loading for collection or search pages
       * Determines whether to load collection products or search results
       * based on presence of searchTerm and collectionId
       *
       * Collection Mode: Uses FastSimon smartCollections API
       * Search Mode: Uses FastSimon fullTextSearch API
       */
      startCollectionPage() {
        if (this.searchTerm !== '' && this.searchTerm === '1' && this.collectionId) {
          whenFastSimonReady(
            () => {
              try {
                if (!window.FastSimonSDK?.smartCollections) {
                  console.warn('FastSimon SDK not available or smartCollections method missing');
                  this.fsError = true;
                  return;
                }
                let callbackFired = false;
                const callbackTimeout = setTimeout(() => {
                  if (!callbackFired) {
                    logFastSimonError('smartCollections callback not received within 15s');
                    this.fsError = true;
                  }
                }, 15000);
                const requestId = ++this.lastRequestId;
                this.pendingRequests += 1;
                const sentNarrow = this.getFilteredNarrowBy();
                window.FastSimonSDK.smartCollections({
                  categoryID: this.collectionId,
                  narrowBy: sentNarrow,
                  page: this.page,
                  productsPerPage: this.productsPerPage,
                  sortBy: this.sortBy,
                  term: this.searchTerm,
                  withAttributes: true,
                  maxFacetValues: 100,
                  facetLimit: 100,
                  includeFacetsFromAllResults: true,
                  callback: response => {
                    callbackFired = true;
                    clearTimeout(callbackTimeout);
                    this.pendingRequests -= 1;
                    if (requestId !== this.lastRequestId) {
                      return;
                    }
                    this.currentSetupRequestId = requestId;
                    this.setupProducts(response);
                    emitter.emit('fs-update', response.payload);
                    setTimeout(() => {
                      const resultsDisplay = document.querySelector('.filter-controls .count');
                      if (resultsDisplay && response.payload?.totalResults) {
                        const expectedText = response.payload.totalResults + ' Results';
                        if (resultsDisplay.innerHTML !== expectedText) {
                          resultsDisplay.innerHTML = expectedText;
                        }
                      }
                      const productCounters = document.querySelectorAll('#productCounter');
                      if (productCounters.length > 0 && response.payload?.totalResults) {
                        const expectedCountText = '(' + response.payload.totalResults + ')';
                        productCounters.forEach(counter => {
                          if (counter.innerHTML !== expectedCountText) {
                            counter.innerHTML = expectedCountText;
                          }
                        });
                      }
                    }, 100);
                    this.isNoResults = response.payload.isNoResults;
                    if (response.payload.products && response.payload.products.length > 0) {
                      this.reportCollectionViewed();
                    }
                  }
                });
              } catch (error) {
                logFastSimonError('smartCollections error', error);
                this.fsError = true;
              }
            },
            {
              onTimeout: () => {
                this.fsError = true;
              }
            }
          );
        } else {
          this.startSearchTermPage();
        }
      },
      reportCollectionViewed() {
        const collectionKey = `${this.collectionId}-${this.page}`;
        if (this.lastReportedCollectionKey.has(collectionKey)) {
          return;
        }
        whenFastSimonReady(() => {
          try {
            if (!window.FastSimonSDK?.event) {
              console.warn('FastSimon SDK not available or event method missing');
              return;
            }
            const promoTiles = this.promoTiles;
            if (!window.FastSimonEventName?.SmartCollectionPreformed) {
              console.warn('FastSimonEventName.SmartCollectionPreformed not found, available events:', Object.keys(window.FastSimonEventName || {}));
              return;
            }
            const turbolink = localStorage.getItem('fromTurboLink');
            window.FastSimonSDK.event({
              eventName: window.FastSimonEventName.SmartCollectionPreformed,
              data: {
                categoryID: this.collectionId,
                query: this.collectionHandle,
                narrowBy: this.narrowBy,
                sortBy: this.sortBy,
                products: this.products?.map(product => product.id),
                promoTiles: promoTiles?.length > 0 ? promoTiles : undefined,
                fromTurboLink: turbolink === 'true'
              }
            });
            this.lastReportedCollectionKey.add(collectionKey);
            localStorage.removeItem('fromTurboLink');
          } catch (error) {
            logFastSimonError('SmartCollectionPreformed event error', error);
          }
        });
      },
      reportSearchResultPageViewed() {
        const searchKey = `${this.searchTerm}-${this.page}`;
        if (this.lastReportedSearchKey.has(searchKey)) {
          return;
        }
        whenFastSimonReady(() => {
          try {
            if (!window.FastSimonSDK?.event) {
              console.warn('FastSimon SDK not available or event method missing');
              return;
            }
            const promoTiles = this.promoTiles;
            if (!window.FastSimonEventName?.SearchPerformed) {
              console.warn('FastSimonEventName.SearchPerformed not found, available events:', Object.keys(window.FastSimonEventName || {}));
              return;
            }
            window.FastSimonSDK.event({
              eventName: window.FastSimonEventName.SearchPerformed,
              data: {
                query: this.searchTerm,
                narrowBy: this.narrowBy,
                sortBy: this.sortBy,
                products: this.products?.map(product => product.id),
                promoTiles: promoTiles?.length > 0 ? promoTiles : undefined
              }
            });
            this.lastReportedSearchKey.add(searchKey);
          } catch (error) {
            logFastSimonError('SearchPerformed event error', error);
          }
        });
      },
      checkCurrentActiveSlider(emittedPID) {
        if (emittedPID !== this.sliderIDActive) {
          this.sliderIDLast = this.sliderIDActive;
          this.sliderIDActive = emittedPID;
        }
      },
      endlessScrollCollectionPage() {
        if (this.searchTerm === '1' && this.collectionId) {
          whenFastSimonReady(
            () => {
              try {
                if (!window.FastSimonSDK?.smartCollections) {
                  console.warn('FastSimon SDK not available or smartCollections method missing');
                  this.fsError = true;
                  return;
                }
                let callbackFired = false;
                const callbackTimeout = setTimeout(() => {
                  if (!callbackFired) {
                    logFastSimonError('smartCollections (endless scroll) callback not received within 15s');
                    this.fsError = true;
                  }
                }, 15000);
                const requestId = ++this.lastRequestId;
                this.pendingRequests += 1;
                const sentNarrow = this.getFilteredNarrowBy();
                window.FastSimonSDK.smartCollections({
                  categoryID: this.collectionId,
                  narrowBy: sentNarrow,
                  sortBy: this.sortBy,
                  page: this.page,
                  productsPerPage: this.productsPerPage,
                  withAttributes: true,
                  callback: response => {
                    callbackFired = true;
                    clearTimeout(callbackTimeout);
                    this.pendingRequests -= 1;
                    if (requestId !== this.lastRequestId) {
                      return;
                    }
                    this.currentSetupRequestId = requestId;
                    this.setupProducts(response);
                    emitter.emit('fs-update', response.payload);
                    this.isNoResults = response.payload.isNoResults;
                    if (response.payload.products && response.payload.products.length > 0) {
                      this.reportCollectionViewed();
                    }
                  }
                });
              } catch (error) {
                logFastSimonError('smartCollections (endless scroll) error', error);
                this.fsError = true;
              }
            },
            {
              onTimeout: () => {
                this.fsError = true;
              }
            }
          );
        } else {
          this.startSearchTermPage();
        }
      },
      endlessScrollSearchTermPage() {
        whenFastSimonReady(
          () => {
            try {
              if (!window.FastSimonSDK?.fullTextSearch) {
                console.warn('FastSimon SDK not available or fullTextSearch method missing');
                this.fsError = true;
                return;
              }
              let callbackFired = false;
              const callbackTimeout = setTimeout(() => {
                if (!callbackFired) {
                  logFastSimonError('fullTextSearch (endless scroll) callback not received within 15s');
                  this.fsError = true;
                }
              }, 15000);
              window.FastSimonSDK.fullTextSearch({
                narrowBy: this.narrowBy,
                page: this.page,
                productsPerPage: this.productsPerPage,
                sortBy: this.sortBy,
                term: this.searchTerm,
                withAttributes: true,
                maxFacetValues: 100,
                facetLimit: 100,
                includeFacetsFromAllResults: true,
                callback: response => {
                  callbackFired = true;
                  clearTimeout(callbackTimeout);
                  this.setupProducts(response);
                  emitter.emit('fs-update', response.payload);
                  this.isNoResults = response.payload.isNoResults;
                  if (response.payload.products && response.payload.products.length > 0) {
                    this.reportSearchResultPageViewed();
                  }
                }
              });
            } catch (error) {
              logFastSimonError('fullTextSearch (endless scroll) error', error);
              this.fsError = true;
            }
          },
          {
            onTimeout: () => {
              this.fsError = true;
            }
          }
        );
      },
      localGetPLPDescription(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductMetafieldOneFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductMetafieldTwoFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductCategoryMetafieldOneCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductCategoryMetafieldTwoCollectionFromFS(productList, index, metafieldStr) {
        return getProductCollectionMetafieldFromFS(productList, index, metafieldStr);
      },
      localGetProductReminderEmbedFromFS(productList, index, metafieldStr) {
        return getProductMetafieldFromFS(productList, index, metafieldStr);
      },
      reportAllPagesUpTo(targetPage, isSearch = false) {
        for (let page = 1; page <= targetPage; page++) {
          if (isSearch) {
            const searchKey = `${this.searchTerm}-${page}`;
            if (!this.lastReportedSearchKey.has(searchKey)) {
              const originalPage = this.page;
              this.page = page;
              this.reportSearchResultPageViewed();
              this.page = originalPage;
            }
          } else {
            const collectionKey = `${this.collectionId}-${page}`;
            if (!this.lastReportedCollectionKey.has(collectionKey)) {
              const originalPage = this.page;
              this.page = page;
              this.reportCollectionViewed();
              this.page = originalPage;
            }
          }
        }
      },
      onCompareKeepOpen(keepOpen) {
        this.compareKeepOpen = keepOpen === true;
        if (!keepOpen) {
          this.showCompareUI = false;
        }
      },
      updateProductsToCompare(newSet) {
        if (!newSet || !(newSet instanceof Set)) {
          this.productsToCompare = new Set();
          this.compareKeepOpen = false;
          this.showCompareUI = false;
          this.productsToCompareKey = 0;
          try {
            sessionStorage.removeItem(this.comparePlpSessionKey);
          } catch (e) {
            console.error('Error updating products to compare:', e);
          }
          return;
        }
        const oldSize = this.productsToCompare.size;
        this.productsToCompare = new Set(Array.from(newSet));
        this.showCompareUI = this.compareKeepOpen || this.productsToCompare.size > 0;
        this.compareKeepOpen = false;
        if (oldSize !== this.productsToCompare.size) {
          this.productsToCompareKey += 1;
        }
        try {
          if (this.productsToCompare.size === 0) {
            sessionStorage.removeItem(this.comparePlpSessionKey);
          } else {
            sessionStorage.setItem(this.comparePlpSessionKey, JSON.stringify(Array.from(this.productsToCompare)));
          }
        } catch (e) {
          console.error('Error updating products to compare:', e);
        }
      },
      getCompareImageForColor(fsProduct, colorName) {
        if (!fsProduct || !colorName) return null;
        const lowerColor = colorName.toLowerCase().trim();
        const findAttr = (att, name) => (att && att.length > 0 ? att.find(item => item[0] === name) : null);
        if (Array.isArray(fsProduct.alt)) {
          for (const alt of fsProduct.alt) {
            if (alt[0]?.toLowerCase().trim() === lowerColor) {
              const images = findAttr(alt[3]?.att, 'Product images');
              if (images?.[1]?.[0]) return images[1][0];
            }
          }
        }
        return null;
      },
      toggleCompareItem(item) {
        const rawId = item?.pid ?? item?.id ?? item?.i ?? item?.productID ?? item?.product_id;
        if (rawId == null || rawId === '') return;
        const itemId = String(rawId);
        if (itemId === 'undefined') return;
        const normalized = { ...item, pid: item.pid ?? item.id ?? item.i ?? item.productID ?? item.product_id };
        const isInSet = Array.from(this.productsToCompare).some(p => String(p?.pid ?? p?.id) === itemId);
        if (!isInSet && this.productsToCompare.size >= 3) return;
        const next = new Set();
        for (const p of this.productsToCompare) {
          const pId = String(p?.pid ?? p?.id);
          if (pId !== itemId) next.add(p);
        }
        if (!isInSet) next.add(normalized);
        this.updateProductsToCompare(next);
      },
      /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
      resolveComparePlpEnabled() {
        if (this.forceCompareOn) return true;
        const root = document.documentElement;
        if (root.classList.contains('kam-plp-compare-off')) return false;
        if (root.classList.contains('kam-plp-compare')) return true;
        const kamJsOverride = window.theme?.kameleoonComparePlpEnabled;
        if (kamJsOverride !== undefined) return kamJsOverride;
        if (this.stickyComparePid) return true;
        const el = document.getElementById('fs-collection-products');
        return el?.getAttribute('data-plp-enable-compare') === 'true';
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      /* --- Kameleoon Compare PLP experiment: remove this method when experiment ends --- */
      comparePlpSignalPresent() {
        const root = document.documentElement;
        return root.classList.contains('kam-plp-compare-off') || root.classList.contains('kam-plp-compare') || window.theme?.kameleoonComparePlpEnabled !== undefined;
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      /* --- Kameleoon Compare PLP experiment: remove this method when experiment ends --- */
      startComparePlpRecheck() {
        this.stopComparePlpRecheck();
        if (this.forceCompareOn || this.comparePlpSignalPresent()) return;
        const maxAttempts = 15;
        const attemptDelay = 200;
        const tick = () => {
          this.comparePlpRecheckAttempts += 1;
          const signalArrived = this.comparePlpSignalPresent();
          if (signalArrived) {
            const resolved = this.resolveComparePlpEnabled();
            if (resolved !== this.comparePlpEnabled) {
              this.comparePlpEnabled = resolved;
              this.checkCompareEnabled();
            }
          }
          if (signalArrived || this.comparePlpRecheckAttempts >= maxAttempts) {
            this.stopComparePlpRecheck();
            return;
          }
          this.comparePlpRecheckTimer = setTimeout(tick, attemptDelay);
        };
        this.comparePlpRecheckTimer = setTimeout(tick, attemptDelay);
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      /* --- Kameleoon Compare PLP experiment: remove this method when experiment ends --- */
      stopComparePlpRecheck() {
        if (this.comparePlpRecheckTimer) {
          clearTimeout(this.comparePlpRecheckTimer);
          this.comparePlpRecheckTimer = null;
        }
      },
      /* --- end Kameleoon Compare PLP experiment --- */
      checkCompareEnabled() {
        /* --- Kameleoon Compare PLP experiment: remove when experiment ends --- */
        this.comparePlpEnabled = this.resolveComparePlpEnabled();
        if (!this.comparePlpEnabled) {
          this.showCompareUI = false;
          return;
        }
        /* --- end Kameleoon Compare PLP experiment --- */
        const el = document.getElementById('fs-collection-products');
        if (!el) return;
        const enableCompare = el.getAttribute('data-plp-enable-compare') === 'true';
        if (!enableCompare) {
          this.showCompareUI = false;
          return;
        }
        const allowedCollections =
          el
            .getAttribute('data-plp-compare-collections')
            ?.split(',')
            .map(id => id.trim())
            .filter(Boolean) || [];
        if (allowedCollections.length > 0) {
          const currentCollectionId = el.getAttribute('data-collection-id');
          const currentNorm = normalizeShopifyCollectionId(currentCollectionId);
          const allowedNorm = allowedCollections.map(normalizeShopifyCollectionId);
          if (!allowedNorm.includes(currentNorm)) {
            this.showCompareUI = false;
            return;
          }
        }
        if (this.productsToCompare.size > 0) {
          this.showCompareUI = true;
        }
      },
      loadCompareProducts() {
        try {
          const stored = sessionStorage.getItem(this.comparePlpSessionKey);
          if (stored) {
            const arr = JSON.parse(stored);
            if (Array.isArray(arr) && arr.length) {
              this.productsToCompare = new Set(arr);
            }
          }
        } catch (e) {
          console.error('Error loading products to compare:', e);
        }
        this.checkCompareEnabled();
      },
      isProductInCompare(product) {
        if (!product) return false;
        const ids = [product.id, product.pid].filter(Boolean).map(String);
        if (ids.some(id => this.compareSetIdsSet.has(id))) return true;
        const alt = product.alt;
        if (Array.isArray(alt)) {
          for (const v of alt) {
            const variantId = v?.[2] || v?.pid || v?.id;
            if (variantId && this.compareSetIdsSet.has(String(variantId))) return true;
          }
        }
        const vra = product.vra;
        if (Array.isArray(vra)) {
          for (const v of vra) {
            const variantId = v?.[1]?.[2] || v?.[2] || v?.id || v?.pid;
            if (variantId && this.compareSetIdsSet.has(String(variantId))) return true;
          }
        }
        return false;
      },
      measureProductTileHeight() {
        const grid = document.getElementById('fs-collection-products-grid');
        if (!grid) return;
        const wrappers = grid.querySelectorAll(':scope > div');
        for (const wrapper of wrappers) {
          if (wrapper.querySelector('.product-grid-item') && wrapper.offsetHeight > 0) {
            this.productTileHeight = wrapper.offsetHeight;
            break;
          }
        }
      },
      // ROLLBACK NOTE: The multi-row min-height below (rows > 1 branch) may cause
      // layout issues where product tiles stretch with whitespace. To roll back,
      // remove the `rows > 1` branch and restore the previous condition:
      //   if (cols >= this.activeGridColumns && this.productTileHeight > 0) {
      //     style['min-height'] = `${rows * this.productTileHeight}px`;
      //   }
      getPromoGridStyle(product) {
        if (!product.promotile) return { position: 'relative' };
        const cols = Math.min(product.width || 1, this.activeGridColumns);
        const rows = product.height || 1;
        const style = { position: 'relative' };
        if (cols > 1) style['grid-column'] = `span ${cols}`;
        if (rows > 1) style['grid-row'] = `span ${rows}`;
        if (this.productTileHeight > 0) {
          if (rows > 1) {
            const grid = document.getElementById('fs-collection-products-grid');
            const rowGap = grid ? parseFloat(getComputedStyle(grid).rowGap) || 0 : 0;
            style['min-height'] = `${rows * this.productTileHeight + (rows - 1) * rowGap}px`;
          } else if (cols >= this.activeGridColumns) {
            style['min-height'] = `${this.productTileHeight}px`;
          }
        }
        return style;
      },
      promoFitsInRow(index, product) {
        const width = product.width || 1;
        if (width <= 1) return true;
        return width <= this.activeGridColumns;
      },
      isInLastRow(index) {
        const cols = this.activeGridColumns;
        const lastRowStart = this.products.length - (this.products.length % cols || cols);
        return index >= lastRowStart;
      }
    },
    computed: {
      compareSetIdsSet() {
        return new Set(
          Array.from(this.productsToCompare || [])
            .map(p => String(p?.pid || p?.id))
            .filter(Boolean)
        );
      },
      promoTiles() {
        return (
          this.products
            ?.filter(product => product.promotile && product.id && product.title)
            .map(product => ({
              id: product.id,
              name: product.title,
              link: product.link || '',
              thumbnail: product.image || ''
            })) || []
        );
      },
      badgeHideConfig() {
        if (this.cachedBadgeConfig) {
          return this.cachedBadgeConfig;
        }
        return {};
      },
      hasActiveFilters() {
        return Array.isArray(this.narrowBy) && this.narrowBy.length > 0;
      },
      activeGridColumns() {
        return this.isMobile ? Number(this.gridSmall) || 2 : Number(this.gridLarge) || 4;
      },
      comparePidForUrl() {
        return this.pendingComparePid || this.stickyComparePid;
      },
      compareCheckboxGateOpen() {
        return this.comparePlpEnabled;
      },
      firstNonPromoProductListIndex() {
        if (!Array.isArray(this.products)) return -1;
        return this.products.findIndex(p => p && p.l && !p.promotile);
      }
    }
  };
</script>

<template :data-show="showPage">
  <div v-if="fsError" class="collection__error">
    <p>There was an error loading products, please reload the page.</p>
  </div>
  <div v-else-if="products.length">
    <div class="isNoResults" v-if="isNoResults">
      <h3 class="gt-h3 suggestions">No results found. Instead we recommend:</h3>
    </div>
    <div class="js-grid" :data-grid-large="Number(gridLarge)" :data-grid-small="Number(gridSmall)" id="fs-collection-products-grid">
      <div v-for="(product, index) in products" :key="product.id" :pid="product.id" :id="`pid-${product.id}`" :style="getPromoGridStyle(product)" v-memo="[product.id, product.l, index, productsToCompareKey, isProductInCompare(product), hasActiveFilters, activeGridColumns, productTileHeight, products.length, comparePlpEnabled]">
        <!-- Kameleoon Compare PLP experiment: remove :kameleoonCompareEnabled when experiment ends -->
        <ProductListItem :fsData="product" :useFsProductData="useFsProductData" :collectionHandle="collectionHandle" :collectionId="collectionId" :badgeHideConfig="badgeHideConfig" :gridLarge="gridLarge ? gridLarge : ''" :gridSmall="gridSmall ? gridSmall : ''" :imageLookUpMax="this.maxImages" :key="product.id" :pid="product.id" :productIndex="index" :productTitle="product.l" :productTypesExcluded="this.productTypesExcluded" :searchTerm="this.searchTerm" :setReminderFormIdPopup="this.setReminderFormIdPopup" :setReminderLinkText="this.setReminderLinkText" :sliderIDActive="sliderIDActive ? sliderIDActive : ''" :sliderIDLast="sliderIDLast ? sliderIDLast : ''" :swatchSuffix="this.swatch_suffix" :showSalePercentage="showSalePercentage" :productsToCompare="productsToCompare" :kameleoonCompareEnabled="compareCheckboxGateOpen" @toggle-compare="toggleCompareItem" @currentCarouselSlideStart="debouncedCheckCurrentActiveSlider" ref="productItems" v-if="product.l" :productPLPDescription="localGetPLPDescription(this.products, index, this.descriptionMetafield)" :productReminderMetafieldEmbed="localGetProductReminderEmbedFromFS(this.products, index, this.productReminderMetafieldEmbedAttr)" :productCategoryMetafieldOne="localGetProductMetafieldOneFromFS(this.products, index, this.productCategoryMetafieldOneAttr)" :productCategoryMetafieldTwo="localGetProductMetafieldTwoFromFS(this.products, index, this.productCategoryMetafieldTwoAttr)" :productCategoryMetafieldOneCollection="localGetProductCategoryMetafieldOneCollectionFromFS(this.products, index, this.productCategoryMetafieldOneCollectionAttr)" :productCategoryMetafieldTwoCollection="localGetProductCategoryMetafieldTwoCollectionFromFS(this.products, index, this.productCategoryMetafieldTwoCollectionAttr)" :collectionTracking="true" :showRating="showRating" :ratingStarColor="ratingStarColor" :ratingCountColor="ratingCountColor" :enableMobilePeekABoo="index === firstNonPromoProductListIndex" :slideIndex="index"> </ProductListItem>
        <ProductListPromo :Title="product.title" :Image="product.image" :Link="product.link" :Pid="product.id" :productIndex="index" v-if="product.promotile && !hasActiveFilters && promoFitsInRow(index, product) && !isInLastRow(index)" :collectionTracking="true" :collectionId="collectionId" :collectionHandle="collectionHandle" :searchTerm="searchTerm" :width="product.width || 1" :height="product.height || 1" :mobileImage="product.mobile_image || ''"></ProductListPromo>
      </div>
    </div>
    <div v-if="showCompareUI" :key="'compare-bar-' + productsToCompareKey">
      <CompareProductsWidget :productsToCompare="productsToCompare" @update:productsToCompare="updateProductsToCompare" :collectionHandle="collectionHandle" :collectionTitle="collectionName" @keep-open="onCompareKeepOpen" />
    </div>
  </div>
</template>

<style lang="scss">
  #fs-collection-products {
    .swatch_button_wrapper .carousel__viewport img {
      width: unset !important;
      max-width: 100%;
    }

    .swatch_button_wrapper.color_swatches .carousel__viewport {
      max-height: 61px;
    }

    .js-grid {
      grid-auto-flow: dense;

      div:not(.loader):empty {
        display: none;
      }

      > div {
        overflow: hidden;
        min-width: 20%;
        min-height: 200px;
      }
    }

    .isNoResults .suggestions {
      text-transform: none;
      margin-top: 22px;
      font-weight: 500;
      line-height: 36px;
      letter-spacing: normal;

      .is-mobile & {
        padding-left: var(--outer);
        padding-right: var(--outer);
      }
    }

    .promo-wrapper .isNoResults {
      margin-top: 20px;
      margin-bottom: 20px;

      .suggestions {
        text-transform: none;
        margin-top: 20px;
        margin-bottom: 20px;

        .suggestions {
          text-transform: none;
          margin-top: 20px;
        }
      }

      .loader {
        animation: product-list-loading 1.5s ease infinite;
        background-color: #ccc;
        aspect-ratio: 0.6;
      }

      @keyframes product-list-loading {
        0% {
          opacity: 1;
        }

        60% {
          opacity: 0.5;
        }

        80% {
          opacity: 0.3;
        }

        100% {
          opacity: 0.9;
        }
      }

      .js-grid {
        column-gap: 15px;
        row-gap: 30px;
      }

      .collection__text-content.wrapper.section-padding {
        padding-left: var(--outer);
        padding-right: var(--outer);
        width: 100%;
        max-width: 100%;

        .is-mobile & {
          padding-left: 0;
          padding-right: 0;
        }
      }

      .product-grid-item__container {
        aspect-ratio: var(--grid-aspect-ratio);
      }

      .carousel__viewport {
        aspect-ratio: var(--grid-aspect-ratio);
      }

      .carousel__track {
        aspect-ratio: var(--grid-aspect-ratio);
      }

      .carousel__slide {
        img {
          aspect-ratio: var(--PRODUCT-GRID-ASPECT-RATIO-DECIMAL);
          background: var(--PRODUCT-GRID-BACKGROUND-COLOR);
          object-fit: var(--PRODUCT-GRID-OBJECT-FIT);
        }
      }
    }

    .is-mobile & {
      .collection .wrapper--full.section-padding {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
</style>
